import PropTypes from "prop-types";
import React, { Component } from "react";
import AdminActions from "../actions/AdminActions.js";
import MembershipDetailsForCurrentUserStore from "../stores/MembershipDetailsForCurrentUserStore";
import CurrentOrganizationIdStore from "../stores/CurrentOrganizationIdStore";
import ChooseOrg from "./ChooseOrg.react";

function getStateFromStores() {
  return {
    availableOrganizations: MembershipDetailsForCurrentUserStore.availableLoginOrganizations().sortBy(
      (o) => o.name
    ),
    currentOrganizationId: CurrentOrganizationIdStore.getState(),
  };
}

class ChooseOrgContainer extends Component {
  constructor(props) {
    super(props);

    this.state = getStateFromStores();
    this._onChange = this._onChange.bind(this);
    this._selectOrg = this._selectOrg.bind(this);
  }

  componentDidMount() {
    this._tryToRedirect();
    this.membershipDetailsSubscription = MembershipDetailsForCurrentUserStore.addListener(
      this._onChange
    );
    this.currentOrganizationIdSubscription = CurrentOrganizationIdStore.addListener(
      this._onChange
    );
  }

  componentDidUpdate() {
    this._tryToRedirect();
  }

  componentWillUnmount() {
    this.membershipDetailsSubscription.remove();
    this.currentOrganizationIdSubscription.remove();
  }

  _tryToRedirect() {
    if (this.state.currentOrganizationId) {
      const { location } = this.props;
      const { router } = this.context;

      if (location.query && location.query.nextPath) {
        router.replace(location.query.nextPath);
      } else {
        router.replace("/");
      }
    }
  }

  _onChange() {
    this.setState(getStateFromStores());
  }

  _selectOrg(orgId) {
    AdminActions.setOrganization(orgId);
  }

  render() {
    if (this.state.availableOrganizations.size == 0) {
      return <p>You have no organizations available. This is not expected.</p>;
    }
    return (
      <ChooseOrg
        availableOrganizations={this.state.availableOrganizations}
        onSelectOrganization={this._selectOrg}
      />
    );
  }
}

ChooseOrgContainer.contextTypes = {
  router: PropTypes.object,
};

ChooseOrgContainer.propTypes = {
  location: PropTypes.object,
};

export default ChooseOrgContainer;
